<app-titulo-paginas titulo="Meu Perfil"></app-titulo-paginas>
<div class="panel panel-default">
  <div class="row ml-card-borders" style="width: 95%; margin-top: 50px">
    <div class="col-lg-3 px-0 ml-aside-perfil ml-right-border">
      <div class="my-2 d-flex" style="justify-content: center; flex-wrap: wrap">
        <img
          [src]="
            token?.user?.pessoa.perfil
              ? token?.user?.pessoa.perfil
              : '../../assets/images/user.png'
          "
          alt="Imagem de Perfil do Usuário"
          class="ml-user-profile d-block rounded-pill"
        />
        <!-- <img
            src="https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
            alt=""
            class="ml-user-profile d-block"
          /> -->
        <button
          type="button"
          class="btn btn-primary my-2"
          style="width: 70%"
          (click)="openCropperDialog($event)"
        >
          Alterar Foto de Perfil
        </button>
      </div>

      <hr class="mx-auto my-0" />

      <mat-form-field class="d-block d-lg-none mx-auto my-2" style="width: 90%; font-weight: bold">
        <mat-label>Selecione uma Opção</mat-label>
        <mat-select
          id="selectValue"
          [(value)]="selectedSection"
          [formControl]="1"
        >
          <mat-option value="1">Informações Pessoais</mat-option>
          <mat-option value="2">Dados Profissionais</mat-option>
          <mat-option value="3">Formas de Contato</mat-option>
          <mat-option value="4">Endereços</mat-option>
          <mat-option value="5">Dados Contratuais</mat-option>
        </mat-select>
      </mat-form-field>

      <ul class="px-0 m-0 d-none d-lg-block" style="list-style-type: none">
        <li (click)="sectionSwitch(1)" class="ml-menu-li">
          Informações Pessoais
        </li>
        <li (click)="sectionSwitch(2)" class="ml-menu-li">
          Dados Profissionais
        </li>
        <li (click)="sectionSwitch(3)" class="ml-menu-li">Formas de Contato</li>
        <li (click)="sectionSwitch(4)" class="ml-menu-li">Endereços</li>
        <li (click)="sectionSwitch(5)" class="ml-menu-li">Dados Contratuais</li>
        <li (click)="sectionSwitch(6)" class="ml-menu-li">Alterar Senha</li>
      </ul>
    </div>

    <div class="col-lg-9 px-0">
      <div class="containerPerfil" [ngSwitch]="selectedSection">
        <div class="" *ngSwitchCase="1">
          <h2>Informações Pessoais</h2>
          <hr />
          <div class="table-responsive">
            <table class="infoTable w-100">
              <tr>
                <td>Nome:</td>
                <th>
                  <p>{{ usuario?.pessoa?.nome | titlecase }}</p>
                </th>
              </tr>
              <tr>
                <td>Sexo</td>
                <th>
                  <p>{{ usuario?.pessoa?.profissional?.sexo | titlecase }}</p>
                </th>
              </tr>
              <tr>
                <td>Nascimento</td>
                <th>
                  <p>{{ usuario?.pessoa?.nascimento | date : 'dd/MM/yyyy' }}</p>
                </th>
              </tr>
              <tr>
                <td>RG</td>
                <th>
                  <p>{{ usuario?.pessoa?.rgie }}</p>
                </th>
              </tr>
              <tr>
                <td>CPF</td>
                <th>
                  <p>{{ usuario?.pessoa?.cpfcnpj }}</p>
                </th>
              </tr>
              <tr>
                <td>Profissional Ativo</td>
                <th>
                  <p class="text-success">
                    <strong>{{
                      usuario?.pessoa?.ativo ? 'Ativo' : 'Inativo'
                    }}</strong>
                  </p>
                </th>
              </tr>
              <tr>
                <td>MEI Ativa</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.meiativa ? 'Sim' : 'Não'
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Data Verificação MEI</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dataverificacaomei
                        ? usuario?.pessoa?.profissional?.dataverificacaomei
                        : '-'
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Observações</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.observacao
                        ? usuario?.pessoa?.observacao
                        : '-'
                    }}
                  </p>
                </th>
              </tr>
            </table>
          </div>
        </div>
        <div class="" *ngSwitchCase="2">
          <h2>Dados Profissionais</h2>
          <hr />
          <div class="table-responsive">
            <table class="infoTable w-100">
              <tr>
                <td>Cargo</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.cargo?.descricao
                        | titlecase
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Setor</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.setor?.descricao
                        | titlecase
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Nº Carteira de Trabalho</td>
                <th>
                  <p>
                    {{ usuario?.pessoa?.profissional?.numerocarteiratrabalho }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>PIS (NIS, PASEP, NIT)</td>
                <th>
                  <p>{{ usuario?.pessoa?.profissional?.pis }}</p>
                </th>
              </tr>
              <tr>
                <td>Categorias CNH</td>
                <th>
                  <p>{{ usuario?.pessoa?.profissional?.categoriacnh }}</p>
                </th>
              </tr>
              <tr>
                <td>Nº Titulo</td>
                <th>
                  <p>
                    {{ usuario?.pessoa?.profissional?.numerotituloeleitor }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Zona Eleitoral</td>
                <th>
                  <p>{{ usuario?.pessoa?.profissional?.zonatituloeleitor }}</p>
                </th>
              </tr>
              <tr>
                <td>Seção Eleitoral</td>
                <th>
                  <p>{{ usuario?.pessoa?.profissional?.secaotituloeleitor }}</p>
                </th>
              </tr>
              <tr>
                <td>Formações</td>
                <th>
                  <p
                    *ngFor="
                      let formacao of usuario?.pessoa?.profissional?.formacoes
                    "
                  >
                    {{ formacao.descricao }}
                  </p>
                </th>
              </tr>
            </table>
          </div>
        </div>
        <div class="" *ngSwitchCase="3">
          <h2>Formas de Contato</h2>
          <hr />
          <div class="row">
            <div class="col-12 mb-2">
              <h3 class="panel-title">
                <i class="fas fa-phone mr-2"></i> Telefones
              </h3>
              <div class="table-responsive">
                <table class="infoTable w-100">
                  <tr>
                    <th>Tipo</th>
                    <th>Número</th>
                    <th>Observação</th>
                  </tr>
                  <tr *ngFor="let telefone of usuario?.pessoa?.telefones">
                    <td>
                      <p>{{ telefone?.pivot?.tipo }}</p>
                    </td>
                    <td>
                      <p>{{ telefone?.telefone }}</p>
                    </td>
                    <td>
                      <p>{{ telefone?.pivot?.descicao }}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="col-12 mt-2">
              <h3 class="panel-title">
                <i class="fas fa-envelope mr-2"></i> E-mails
              </h3>
              <div class="table-responsive">
                <table class="infoTable w-100">
                  <tr>
                    <th>Tipo</th>
                    <th>Número</th>
                    <th>Observação</th>
                  </tr>
                  <tr *ngFor="let email of usuario?.pessoa?.emails">
                    <td>{{ email?.pivot?.tipo }}</td>
                    <td>{{ email?.email }}</td>
                    <td>{{ email?.pivot?.descricao }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="" *ngSwitchCase="4">
          <h2>Endereços</h2>
          <hr />
          <div class="table-responsive">
            <table class="enderecoTable w-100">
              <tr>
                <th>Tipo</th>
                <th>Cidade/UF</th>
                <th>CEP</th>
                <th>Rua</th>
                <th>Bairro</th>
                <th>Nº</th>
                <th>Descrição</th>
              </tr>
              <tr *ngFor="let endereco of usuario?.pessoa?.enderecos">
                <td>
                  <p>{{ endereco?.tipo }}</p>
                </td>
                <td>
                  <p>
                    {{ endereco?.cidade?.nome }} - {{ endereco?.cidade?.uf }}
                  </p>
                </td>
                <td>
                  <p>{{ endereco?.cep }}</p>
                </td>
                <td>
                  <p>{{ endereco?.rua }}</p>
                </td>
                <td>
                  <p>{{ endereco?.bairro }}</p>
                </td>
                <td>
                  <p>{{ endereco?.numero }}</p>
                </td>
                <td>
                  <p>{{ endereco?.descricao }}</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="" *ngSwitchCase="5">
          <h2>Dados Contratuais</h2>
          <hr />
          <div class="table-responsive">
            <table class="infoTable disableLast w-100">
              <tr>
                <td>Tipo de Salário</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dadoscontratual
                        ?.tiposalario
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Salário</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dadoscontratual?.salario
                        | currency : 'BRL'
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Data de Admissão</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dadoscontratual?.admissao
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Data de Demissão</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dadoscontratual?.demissao
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Carga Horária</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dadoscontratual
                        ?.cargahoraria
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Insalubridade</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dadoscontratual
                        ?.insalubridade
                        ? 'Sim'
                        : 'Não'
                    }}
                  </p>
                </th>
              </tr>
              <tr>
                <td>Percentual Insalubridade</td>
                <th>
                  <p>
                    {{
                      usuario?.pessoa?.profissional?.dadoscontratual
                        ?.percentualinsalubridade
                    }}
                  </p>
                </th>
              </tr>
            </table>
          </div>
          <hr />
          <div class="table-responsive">
            <table class="infoTable w-100">
              <tr>
                <th style="width: 50%">Benefícios</th>
                <th>Valor</th>
              </tr>
              <tr
                *ngFor="let item of usuario?.pessoa?.profissional?.beneficios"
              >
                <td>
                  <p>
                    {{ item?.beneficio?.descricao | titlecase }}
                  </p>
                </td>
                <td>
                  <p>
                    {{ item?.beneficio?.valor | currency : 'BRL' }}
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <div class="table-responsive">
            <table class="infoTable w-100">
              <tr>
                <th style="width: 50%">Convênio</th>
                <th>Valor</th>
              </tr>
              <tr
                *ngFor="
                  let convenio of usuario?.pessoa?.profissional?.convenios
                "
              >
                <td>
                  <p>
                    {{ convenio.descricao | titlecase }}
                  </p>
                </td>
                <td>
                  <p>
                    {{ convenio.valor | currency : 'BRL' }}
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <hr />
          <h2>Dados Bancários</h2>
          <div class="table-responsive">
            <table class="enderecoTable w-100">
              <tr>
                <th>Banco</th>
                <th>Agência</th>
                <th>Conta</th>
                <th>Digito</th>
                <th>Tipo</th>
              </tr>
              <tr *ngFor="let db of usuario?.pessoa?.dadosbancario">
                <td>
                  <p>{{ db?.banco?.descricao }}</p>
                </td>
                <td>
                  <p>
                    {{ db.agencia }}
                  </p>
                </td>
                <td>
                  <p>{{ db.conta }}</p>
                </td>
                <td>
                  <p>{{ db.digito }}</p>
                </td>
                <td>
                  <p>{{ db.tipo }}</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="" *ngSwitchCase="6">
          <h2>Alterar Senha</h2>
          <hr />
          <form [formGroup]="formulario">
            <div class="panel-body">
              <div class="row linha-editor">
                <div class="col-lg-12">
                  <div class="alert alert-warning alert-madelife-warning">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-hidden="true"
                    >
                      ×
                    </button>
                    <span
                      ><strong
                        ><i class="fas fa-exclamation-triangle"></i> Atenção:
                      </strong>
                      As senhas diferenciam maiúsculas de minúsculas e devem
                      conter no mínimo 8 caracteres.</span
                    >
                  </div>
                  <div class="row" style="justify-content: center">
                    <div class="col-8">
                      <div class="form-group">
                        <label for="password">Digite sua Senha Atual</label>
                        <div class="input-group mb-3">
                          <span class="input-group-text"
                            ><i class="fas fa-lock"></i
                          ></span>
                          <input
                            [type]="isTextFieldType1 ? 'password' : 'text'"
                            class="form-control"
                            name="senha"
                            formControlName="password"
                            placeholder="Sua senha atual"
                          />
                          <span
                            class="input-group-text"
                            (click)="isTextFieldType1 = !isTextFieldType1"
                            style="cursor: pointer"
                            ><i
                              class="fas"
                              [ngClass]="{
                                'fa-eye': !isTextFieldType1,
                                'fa-eye-slash': isTextFieldType1
                              }"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="form-group">
                        <label for="password">Digite a Nova Senha</label>
                        <div class="input-group mb-3">
                          <span class="input-group-text"
                            ><i class="fas fa-lock"></i
                          ></span>
                          <input
                            [type]="isTextFieldType2 ? 'password' : 'text'"
                            class="form-control"
                            name="newPassword"
                            formControlName="newPassword"
                            placeholder="Sua senha atual"
                          />
                          <span
                            class="input-group-text"
                            (click)="isTextFieldType2 = !isTextFieldType2"
                            style="cursor: pointer"
                            ><i
                              class="fas"
                              [ngClass]="{
                                'fa-eye': !isTextFieldType2,
                                'fa-eye-slash': isTextFieldType2
                              }"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="form-group">
                        <label for="password">Repita a Nova Senha</label>
                        <div class="input-group mb-3">
                          <span
                            class="input-group-text"
                            (click)="isTextFieldType3 = !isTextFieldType3"
                            style="cursor: pointer"
                            ><i class="fas fa-lock"></i
                          ></span>
                          <input
                            [type]="isTextFieldType3 ? 'password' : 'text'"
                            class="form-control"
                            name="confirmNewPassword"
                            formControlName="confirmNewPassword"
                            placeholder="Sua senha atual"
                          />
                          <span
                            class="input-group-text"
                            style="cursor: pointer"
                            (click)="isTextFieldType3 = !isTextFieldType3"
                            ><i
                              class="fas"
                              [ngClass]="{
                                'fa-eye': !isTextFieldType3,
                                'fa-eye-slash': isTextFieldType3
                              }"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-success rounded-pill"
                      [disabled]="
                        !formulario.valid ||
                        formulario.value.newPassword !=
                          formulario.value.confirmNewPassword" (click)="alterarSenha()">
                      Alterar Senha
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
